module.exports = __webpack_public_path__ + "static/media/customer-address-delete.56ee7bce.svg";